/* global window */

import * as constants from './static'
const w = window || {}
const windowConstants = w.adEngineUI || {}

/* Export Object containing the static configuration, overridden by any
  that we take from the environment variables present at build-time */
export const config = { ...constants, ...windowConstants }
